/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import moment from 'jalali-moment'

import './Card.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { useNavigate } from 'react-router-dom'

import { useSelector, useStore, useDispatch } from 'react-redux'
import { ToRial } from '../../services/money'

import { get, post } from '../../services/https'

import PizzaBox from '../../assets/svg/Pizza.svg'

import { emptyBasketAction } from '../../redux/store/Basket'

export default function index() {
  function between(min, max) {  
    return Math.floor(
      Math.random() * (max - min + 1) + min
    )
  }

  const navigate = useNavigate()
  const date = new Date()

  const orderNumber = moment(date).locale('fa').format('MMDD') + between(10000, 99999)

  if (localStorage.getItem('shopId') === null) {
    navigate('/')
  }

  const stores = useStore()
  const dispatch = useDispatch()

  const [items, setItems] = useState([])
  const [shippingCost, setShippingCost] = useState(0)
  const [minimumOrder, setMinimumOrder] = useState(0)
  const [productsTotal, setProductsTotal] = useState(0)
  const [offCode, setOffCode] = useState('')
  const [offCodePercent, setOffCodePercent] = useState(0)
  const [price, setPrice] = useState(0)
  // const [itemPrice, setItemPrice] = useState(0)
  const [productCount, setProductCount] = useState(0)
  const [canCode, setCanCode] = useState(true)
  const [userId, setUserId] = useState('')
  const [buttonClick, setButtonClick] = useState(false)
  const [typeCode, setTypeCode] = useState('offcode')

  const basket = useSelector(state => state.basket)

  useEffect(() => {
    const store = stores.getState()
    setItems(store.basket)

    let itemPrice = 0
    let itemIds = []
    let itemCount = 0
    store.basket.map(item => {
      itemIds.push(item._id)
      itemPrice = itemPrice + item.allPrice
      itemCount += item.count
    })
    setPrice(itemPrice)
    setProductCount(itemCount)
    setProductsTotal(itemPrice)

    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        setUserId(response.data.data.userId)
        get(`/api/front/users/${response.data.data.userId}`)
          .then(response => {
          }).catch(error => {
            notify('error', 'ابتدا ثبت نام / ورود کنید')
            setTimeout(() => {
              navigate('/login')
            }, 3000)
          })
      }).catch(error => {
        notify('error', 'ابتدا ثبت نام / ورود کنید')
        setTimeout(() => {
          navigate('/login')
        }, 3000)
      })

    get(`/api/front/setting/${localStorage.getItem('shopId')}`)
      .then(response => {
        if (store.orderWay[0].data.type === 'peyk') {
          setShippingCost(response.data.data.shippingCost)
          setPrice(itemPrice + response.data.data.shippingCost)
        } else if (store.orderWay[0].data.type === 'self') {
          setShippingCost(0)
          setPrice(itemPrice)
        }
        setMinimumOrder(response.data.data.minimumOrder)
      }).catch(error => {
        setTimeout(() => {
          navigate('/menu')
        }, 2000)
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [basket, productCount, stores])

  const offCodeHandler = () => {
    if (typeCode === 'offcode') {
      if (offCode.length >= 2 && canCode) {
        post('/api/front/offcode/validate', {
          code: offCode
          }).then(response => {
            if (response.data.success) {
              setCanCode(false)
              setPrice(String(price - (response.data.data.percent * (price / 100))))
              setOffCodePercent(response.data.data.percent)
              notify('success', 'کد تخفیف اعمال شد')
            }
          }).catch(error => {
            if (error.response.data.success === false) {
              setOffCodePercent(0)
              notify('error', error.response.data.messageFa)
            }
          })
      } else if(canCode === false) {
        notify('error', 'کد تخفیف استفاده شده است')
      } else {
        notify('error', 'کد تخفیف نامعتبر است')
      }
    } else if(typeCode === 'ccoffcode') {
      if (offCode.length >= 2 && canCode) {
        post('/api/front/cc/offcode/validate', {
          code: offCode,
          price: price,
          userId: userId
          }).then(response => {
            if (response.data.data.priceType === 'static') {
              setCanCode(false)
              setPrice(String(price - response.data.data.codePrice))
              setOffCodePercent(response.data.data.percent)
              notify('success', 'کد تخفیف اعمال شد')    
            } else if (response.data.data.priceType === 'percent') {
              setCanCode(false)
              setPrice(String(price - (response.data.data.codePercent * (price / 100))))
              setOffCodePercent(response.data.data.percent)
              notify('success', 'کد تخفیف اعمال شد')
            }
          }).catch(error => {
            if (error.response.data.success === false) {
              setOffCodePercent(0)
              notify('error', error.response.data.messageFa)
            }
          })
      } else if(canCode === false) {
        notify('error', 'کد تخفیف استفاده شده است')
      } else {
        notify('error', 'کد تخفیف نامعتبر است')
      }
    }
  }

  const goToBankHandler = () => {
    if (minimumOrder >= price) {
      notify('error', `حداقل سفارش ${ToRial(String(minimumOrder))} تومان می باشد`)
    } else {
      setButtonClick(true)
      const store = stores.getState()
      post('/api/front/payment', {
        amount: price,
        description: 'رستوران کانولی',
        userId: userId
      }).then(responseBank => {
        setButtonClick(true)
          post('/api/front/order', {
            basket :store.basket, 
            orderWay: store.orderWay[0].data, 
            discount: offCode === '' ? ' ' : offCode, 
            orderNumber: String(orderNumber),
            productsCount: productCount,
            productsTotal: productsTotal,
            shippingCost: shippingCost,
            total: price,
            totalDiscount: offCode === '' ? ' ' : (price - (price - (offCodePercent * (price / 100)))),
            authority: responseBank.data.data.authority,
            user: userId,
            branch: localStorage.getItem('shopId')
          }).then(response => {
            if (response.data.success) {
              window.location.href=responseBank.data.data.url
              dispatch(emptyBasketAction())
              const basketArray = []
              basket.map(item => {
                return basketArray.push(item)
              })
            }
          }).catch(error => {
            // console.log(error)
          })
      }).catch(error => {
        setButtonClick(false)
        notify('error', 'خطا در ارسال اطلاعات')
      })
    }
  }

  return (
    <div id='card'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
        <div className="row">
          <div className='cardTitle'>سبد خرید</div>
          <div className='emptyBasketStyle'>
          </div>
        </div>
        { items ? items.map((item, index) => (
          <div className='foodItem' key={index}>
            <div className='foodItemTitle'>{item.name}</div>
            <div className='details'>
              <span>{ToRial(String(item.price))} تومان</span>
              <span className='detailsCount'>
                <span className='count'> تعداد : &nbsp;</span>
                <span className='count'> ( { item.count } ) </span>
              </span>
              <span>{ToRial(String(item.allPrice))} تومان</span>
            </div>
            <div className='trashIcon'>
            </div>
          </div>
        )) : '' }

        { items.length === 0 ? 
          (
            <div className='emptyBasket'>
              <img src={PizzaBox} alt='pizza' />
              سبد خرید شما خالی است
            </div>
          ) : '' }

        <hr className='cardLine' />
        <div className='cardPrice'>
          <span>هـزینه ارسال :</span>
          <span>{ToRial(String(shippingCost))} تومان</span>
        </div>
        <div className='cardPrice'>
          <span>هـزینه کل :</span>
          <span>{ToRial(String(price))} تومان</span>
        </div>

        <hr className='cardLine' />

        <div className='typeOfCode'>
          <span>
            نوع تخفیف را مشخص کنید 
          </span>
        </div>

        <div className='typeOfCodeSelect'>
          <span>
            <input onClick={e => setTypeCode(e.target.id)} defaultChecked='checked' type="radio" name="typeCode" id="offcode" />
            کد تخفیف
          </span>
          <span>
            <input onClick={e => setTypeCode(e.target.id)} type="radio" name="typeCode" id="ccoffcode" />
            باشگاه مشتریان
          </span>
        </div>

        <div className='cardOff'>
          <span>کد تخفیف :</span>
          <span>
            <input readOnly={canCode ? '' : true} onChange={e => setOffCode(e.target.value)} type='text' placeholder='کد تخفیف' />
          </span>
        </div>
        <div className='cardOffButton'>
          <button onClick={offCodeHandler}>ثبت کد تخفیف</button>
        </div>
        <div className='countinueButton'>
          <button onClick={goToBankHandler} style={buttonClick ? { display: 'none' } : {  }}>تکمیل فرآیند خرید</button>
          <button style={buttonClick ? {  } : { display: 'none' }}>در حال انتقال به درگاه بانکی ... </button>
        </div>
      </div>
      <Footer page={'card'} />
    </div>
  )
}
